/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { format } from "date-fns";
import Modal from "../../../../components/common/Modal/Modal";
import Button from "../../../../components/common/Button";
import Styles from "./GohonzonInventoryModal.styles";
import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
import InputField from "../../../../components/common/new/InputField/InputField";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import { AlertStatus, GOHONZON_OPTIONS } from "../../../../contants";
import DatePicker from "../../../../components/common/new/DatePicker/DatePicker";
import Gohonzon from "../../../../services/api/gohonzon";

function GohonzonInventoryModal({ open, onClose, toast, refreshList }) {
  const [selectedGohonzonType, setSelectedGohonzonType] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [quantity, setQuantity] = useState("");

  const onDateSelect = (appointedAt) => {
    setSelectedDate(new Date(appointedAt));
  };

  const handleGohonzonTypeChange = (event) => {
    setSelectedGohonzonType(event.target.value);
  };

  const onCloseModal = () => {
    setSelectedGohonzonType("");
    setSelectedDate(new Date());
    setQuantity("");
    onClose();
  };

  const onSubmit = async () => {
    try {
      const data = {
        gohonzonType: selectedGohonzonType,
        dateOfReceivingGohonzon: selectedDate,
        quantity,
        updateType: "ADDITION_HQ",
      };
      await Gohonzon.addGohonzonMasterData(data);
      toast.show("Gohonzon Added Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onCloseModal();
        refreshList();
      }, 2000);
    } catch (error) {
      console.log(error);
      toast.show(error.message, AlertStatus.ERROR);
    }
  };
  return (
    <Box>
      <Modal
        open={open}
        onClose={onCloseModal}
        customStyle={{ top: "35%", left: "50%" }}
      >
        <Box>
          <Box style={Styles.topContainer}>
            <Typography style={Styles.title}>Add New Gohonzon</Typography>
          </Box>
          <Box>
            <Typography variant="mini" color="#8C8C8C">
              Create entries for the gohonzon received from the Headquarters.
            </Typography>
          </Box>
          <Box paddingTop="20px">
            <Box width="100%" marginRight="7.5%">
              <Dropdown
                value={selectedGohonzonType}
                options={GOHONZON_OPTIONS}
                label="Gohonzon Type"
                onChange={handleGohonzonTypeChange}
                inputProps={{ required: true }}
              />
            </Box>
          </Box>
          <Box paddingTop="20px">
            <Box width="100%" marginRight="7.5%">
              <Box display="flex" justifyContent="space-between">
                <Typography color="#8C8C8C">
                  Date Of Receiving Gohonzon
                </Typography>
                <DatePicker
                  defaultValue={selectedDate}
                  disableFuture
                  onDateSelect={onDateSelect}
                >
                  <Typography
                    weight={500}
                    variant="small"
                    style={{
                      border: "1px solid #897c6f ",
                      padding: "5px 5px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {selectedDate ? format(selectedDate, "dd-MM-yyyy") : "NA"}
                    <CalendarMonthOutlinedIcon style={{ paddingLeft: "5px" }} />
                  </Typography>
                </DatePicker>
              </Box>
            </Box>
          </Box>
          <Box paddingTop="20px">
            <Box width="100%" marginRight="7.5%">
              <InputField
                value={quantity}
                type="number"
                label="Enter No of Gohonzon Recieved"
                onChange={(event) => setQuantity(event.target.value)}
                inputProps={{ required: true }}
              />
            </Box>
          </Box>
          <Box style={{ display: "flex", gap: 10 }}>
            <Button
              variant="contained"
              style={CommonStyles.buttonStyle}
              label="UPDATE"
              type="submit"
              onClick={onSubmit}
            />
            <Button
              variant="outlined"
              onClick={onClose}
              style={CommonStyles.buttonStyle}
              label="CANCEL"
            />
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default GohonzonInventoryModal;
